import { Routes, Route, Navigate } from 'react-router-dom';
import MemberRegistration from '@/Pages/Members/MemberRegistration/MemberRegistration';
import MembersList from '@/Pages/Members/MembersList/MembersList';

function Members() {
  return (
    <Routes>
      <Route path="/" element={<MembersList />} />
      <Route path="/cadastro" element={<MemberRegistration />} />
      <Route path="/:memberId" element={<MemberRegistration />} />

      <Route path="*" element={<Navigate to="/not-found" replace />} />
    </Routes>
  );
}

export default Members;
